import { render, staticRenderFns } from "./group_table.vue?vue&type=template&id=096f0174"
import script from "./group_table.vue?vue&type=script&lang=js"
export * from "./group_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports